import './App.css';
import NavBar from './navbar';
import Footer from './footer';
import Home from './home';
import JoinUs from './joinUs';
import ContactUs from './contactUs';
import SupportUs from './supportUs';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import ImageCarousel from "./imageCarousel";
import Seo from './seo';

function App() {
  return (
    <div className="App">
      <Router>
        <Seo />
        <NavBar />
        <main className="mainContent">
          <section className="hero" aria-labelledby="site-title">
            <div className="hero__glow" aria-hidden="true" />
            <div className="hero__intro">
              <p className="eyebrow">University of New Mexico</p>
              <h1 id="site-title">
                Lobo
                <span>Powerlifting</span>
              </h1>
              <div className="hero__rule" aria-hidden="true">
                <span />
              </div>
              <p className="hero__federation">Powerlifting America</p>
            </div>
            <ImageCarousel />
          </section>

          <div className="routeContent" id="page-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/join" element={<JoinUs />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/support" element={<SupportUs />} />
            </Routes>
          </div>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
